import { compact } from 'lodash';
import React from 'react';
import { Message } from '../../../components/Message/Message';
import { Product, getCombinedProducts, getProductName } from '../../../model/product';
import { useRemoteData } from '../../../model/data';
import { Spinner } from '../../../components/Spinner/Spinner';
import { Link } from 'react-router-dom';
import { productPath, eventPath } from '../../../routes';
import { Stack } from '../../../components/Stack/Stack';
import { t } from '../../../locales/translate';

export function CombinedProducts({ product }: { product: Product }): JSX.Element {
  const [productData, loading, error] = useRemoteData(
    () => getCombinedProducts(product.id),
    (db) => {
      return db.table('products').where({ slug: product.id })[0] || db.table('products').where({ id: product.id })[0];
    }
  );

  if (!loading && error) {
    return <div>There was an error loading combined products</div>;
  }

  return (
    <div className="product-header__combined">
      <Message title={t.model.product.partOfBundle}>
        {loading ? (
          <Spinner text={t.model.product.loadingCombinedProducts} />
        ) : (
          <Stack size="sm">
            <p>
              <strong>{t.model.product.possibleCombinations}</strong>
            </p>
            <ul>
              {productData.combinedProducts?.map((line) => {
                const lineIds = compact(line.map((item) => item.id)).join('-');

                return (
                  <li key={lineIds}>
                    {line.map((item, index) => {
                      return (
                        <div key={item.id}>
                          {index === 0 && <span>{t.model.product.thisProductAnd} </span>}
                          <Link
                            key={item.id}
                            to={item.__typename === 'Event' ? eventPath(item.id) : productPath(item.id)}
                            className="underline"
                          >
                            {getProductName(item)}
                          </Link>
                          {index !== line.length - 1 && <span> {t.general.and.toUpperCase()} </span>}
                        </div>
                      );
                    })}
                  </li>
                );
              })}
            </ul>
          </Stack>
        )}
      </Message>
    </div>
  );
}
